import { Card, Col, Row, Segmented, Tag, Typography } from "antd";
import React from "react";
import ContactInfo from "../../../../components/ContactInfo";
import InfiniteScrollList from "../../../../components/Forms/ListView/InfiniteScrollList";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";
import moment from "moment";
import SmallProfileCard from "../../../../components/ContactInfo/SmallProfileCard";
import { constants } from "../../../../constants/common";
const { Text } = Typography;

const disabledPastDate = (current) => {
    return current && current < moment().subtract(10, 'days').startOf('day');
}

const disabledDate = (current) => {
    const getLast10Year = moment().subtract(10, 'years');
    return current && current > moment(getLast10Year).endOf('day');
}

const EmployeeDirectory = () => {
    const [view, setView] = React.useState('Grid');

    const userConfigs: MasterConfigs = {
        api: () => '/users',
        title: 'Users',
        isActionTab: true,
        modalTitle: (action) => `${action} User`,
        isSteps: true,
        searchKeys: ['firstName', 'lastName', 'email', 'employeeId'],
        getColumns: () => {
            return [
                {
                    title: "Employee",
                    align: 'left',
                    width: 200,
                    ellipsis: true,
                    render: (_, record) => <SmallProfileCard
                        name={constants.GET_FULL_NAME(record)}
                        avatar={record?.avatar}
                        subTitle={record?.employeeId}
                    />
                },
                {
                    title: 'Email',
                    dataIndex: 'email',
                    key: 'email',
                    width: 200,
                    ellipsis: true,
                    isSearch: true,
                },
                {
                    title: 'Gender',
                    dataIndex: 'gender',
                    key: 'gender',
                    align: 'center',
                    width: 100,
                    isSearch: true,
                },
                {
                    title: 'Designation',
                    dataIndex: 'jobTitles',
                    key: 'jobTitles',
                    width: 150,
                    render: (item) => {
                        if (item) {
                            return item?.name;
                        }
                    },
                },
                {
                    title: 'Is On Bench',
                    dataIndex: 'isOnBench',
                    key: 'isOnBench',
                    align: 'center',
                    width: 150,
                    render: (text) => text ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>,
                },
                {
                    title: 'Is On Notice Period',
                    dataIndex: 'isOnNoticePeriod',
                    key: 'isOnNoticePeriod',
                    align: 'center',
                    width: 150,
                    render: (text) => text ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>,
                },
                {
                    title: 'Probation End Date',
                    dataIndex: 'probationPolicy',
                    key: 'probationPolicy',
                    isSearch: true,
                    width: 150,
                    align: 'center',
                    render: (text, record) => {
                        if (record.probationEndDate) {
                            return moment(record.probationEndDate).format('DD MMM, YYYY');
                        } else {
                            if (text?.probationPeriod) {
                                return moment(record.dateOfJoining).add(text.probationPeriod, text.periodType.toLowerCase()).format('DD MMM, YYYY');
                            }
                        }
                    },
                },
                {
                    title: 'Account Status',
                    dataIndex: 'isBlock',
                    key: 'isBlock',
                    align: 'center',
                    width: 150,
                    render: (text) => {
                        return !text ? <Tag color="green">{'Active'}</Tag> : <Tag color="red">Blocked</Tag>;
                    }
                },
                {
                    title: 'Joining Date',
                    dataIndex: 'dateOfJoining',
                    key: 'dateOfJoining',
                    isSearch: true,
                    width: 150,
                    align: 'center',
                    render: (text) => moment(text).format('DD MMM, YYYY'),
                },
            ];
        },
        getFormColumns: () => {
            return [
                {
                    tabName: 'Basic Details',
                    api: () => '/users',
                    storeObject: true,
                    getChiledForm: () => [
                        {
                            label: 'First Name',
                            name: 'firstName',
                            type: 'text',
                            rules: [{
                                required: true,
                                message: 'First Name is required'
                            }]
                        },
                        {
                            label: 'Middel Name',
                            name: 'middelName',
                            type: 'text',
                            isRequired: false,
                        },
                        {
                            label: 'Last Name',
                            name: 'lastName',
                            type: 'text',
                            rules: [{
                                required: true,
                                message: 'Last Name is required'
                            }]
                        },
                        {
                            label: 'Gender',
                            name: 'gender',
                            rules: [{
                                required: true,
                                message: 'Gender is required'
                            }],
                            type: 'select',
                            children: [
                                { name: 'Male', value: 'Male' },
                                { name: 'Female', value: 'Female' },
                                { name: 'Other', value: 'Other' },
                            ],
                        },
                        {
                            label: 'Date Of Birth',
                            name: 'dob',
                            rules: [{
                                required: true,
                                message: 'Date Of Birth is required'
                            }],
                            dateProps: {
                                disabledDate: disabledDate,
                                format: 'DD MMM YYYY',
                            },
                            type: 'date',
                        },
                        {
                            span: 8
                        },
                        {
                            label: 'Work Email',
                            name: 'workEmail',
                            type: 'text',
                            rules: [{
                                required: true,
                                message: 'Work Email is required'
                            }, {
                                type: 'email',
                                message: 'Invalid email address'
                            }],
                        },
                        {
                            label: 'Email',
                            name: 'email',
                            type: 'text',
                            rules: [{
                                required: true,
                                message: 'Email is required'
                            }, {
                                type: 'email',
                                message: 'Invalid email address'
                            }],
                        },
                        {
                            span: 8
                        },
                        {
                            label: 'Mobile',
                            name: 'mobile',
                            type: 'number',
                            rules: [{
                                required: true,
                                message: 'Mobile is required'
                            }, {
                                pattern: /^[0-9]{10}$/,
                                message: "Mobile number must be 10 digits long!",
                            }],
                        },
                        {
                            label: 'Work Type',
                            name: 'workType',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Work Type is required'
                            }],
                            isCombo: true,
                        },
                        {
                            span: 8
                        },
                        {
                            label: 'Number Serise',
                            name: 'numberSeries',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Number Serise is required'
                            }],
                            isCombo: true,
                        },
                        // {
                        //     label: 'Employee Id',
                        //     name: 'employeeId',
                        //     type: 'text',
                        //     inputProps: { disabled: true },
                        // },
                    ],
                },
                {
                    api: () => '/users',
                    tabName: 'Work Type',
                    getValue: (userData) => userData._id,
                    getChiledForm: () => [
                        {
                            label: 'Date Of Joining',
                            name: 'dateOfJoining',
                            rules: [{
                                required: true,
                                message: 'Date Of Joining is required'
                            }],
                            type: 'date',
                        },
                        {
                            label: 'Role',
                            name: 'role',
                            rules: [{
                                required: true,
                                message: 'Designation is required'
                            }],
                            type: 'select',
                            isCombo: true,
                        },
                        {
                            label: 'Job Title',
                            name: 'jobTitles',
                            rules: [{
                                required: true,
                                message: 'Job Title is required'
                            }],
                            type: 'select',
                            isCombo: true,
                        },
                        {
                            label: 'Time Type',
                            name: 'timeType',
                            type: 'select',
                            isCombo: true,
                            rules: [{
                                required: true,
                                message: 'Time type is required'
                            }],
                        },
                        {
                            label: 'Reporting Manager',
                            name: 'reportingManager',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Reporting Manager is required'
                            }],
                            isCombo: true,
                        },
                        { span: 8 },
                        {
                            label: 'Legal Entity',
                            name: 'legalEntity',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Legal entity is required'
                            }],
                            isCombo: true,
                        },
                        {
                            label: 'Business Unit',
                            name: 'businessUnit',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Business unit is required'
                            }],
                            isCombo: true,
                        },
                        {
                            label: 'Department',
                            name: 'department',
                            type: 'select',
                            isCombo: true,
                            rules: [{
                                required: true,
                                message: 'Department is required'
                            }],
                        },
                        {
                            label: 'Location',
                            name: 'location',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Location is required'
                            }],
                            isCombo: true,
                        },
                        {
                            type: 'custom',
                            span: 24,
                            label: 'Advance',
                            render: () => <Text style={{ color: '#1677ff' }} strong>Advance</Text>,
                        },
                        {
                            label: 'Probation Policy',
                            name: 'probationPolicy',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Probation is required'
                            }],
                            isCombo: true,
                        },
                        {
                            label: 'Notice Period',
                            name: 'noticePeriod',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Notice period is required'
                            }],
                            isCombo: true,
                        },
                    ],
                },
                {
                    api: () => '/users',
                    updateOrCreateAPI: '/salaries',
                    tabName: 'Work Details',
                    getValue: (userData) => userData._id,
                    getChiledForm: () => [
                        {
                            label: 'Invite Employee to login',
                            name: 'inviteEmployeetoLogin',
                            type: 'checkbox',
                        },
                        // {
                        //     label: 'Enable onboarding flow',
                        //     name: 'enableOnboardingFlow',
                        //     type: 'checkbox',
                        // },
                        // {
                        //     label: 'Select Onboarding Flow',
                        //     name: 'onboardingFlow',
                        //     type: 'select',
                        //     selectProps: { placeholder: 'Select Onboarding Flow' },
                        //     children: [
                        //         { name: 'Basic Details', value: 'Basic Details' },
                        //         { name: 'Work Type', value: 'Work Type' },
                        //         { name: 'Salary', value: 'Salary' },
                        //         { name: 'Doccuments', value: 'Doccuments' },
                        //     ],
                        // },
                        {
                            type: 'custom',
                            span: 24,
                            render: () => <Text strong>Time & Attandance Settings</Text>
                        },
                        {
                            label: 'Leave Plans',
                            name: 'leavePlans',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            label: 'Shift Type',
                            name: 'shiftType',
                            type: 'select',
                            children: [],
                            rules: [{ required: true, message: 'Field is required' }],
                            isCombo: true,
                        },
                        {
                            label: 'Weekly Off',
                            name: 'weeklyOff',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            label: 'Attendance Number',
                            name: 'attendanceNumber',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            label: 'Holiday List',
                            name: 'holidayList',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            type: 'custom',
                            span: 24,
                            render: () => <Text strong>Attendance Tracking Settings</Text>
                        },
                        {
                            label: 'Attandance Capture Scheme',
                            name: 'attandanceCaptureScheme',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            label: 'Attandance Tracking Policy',
                            name: 'attandanceTrackingPolicy',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            label: 'Overtime Policy',
                            name: 'overtimePolicy',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        },
                        {
                            type: 'custom',
                            span: 24,
                            render: () => <Text strong>Other Settings</Text>
                        },
                        {
                            label: 'Expense Policy',
                            name: 'expensePolicy',
                            type: 'select',
                            isCombo: true,
                            rules: [{ required: true, message: 'Field is required' }],
                        }
                    ],
                },
                {
                    api: () => '/users',
                    tabName: 'Compansation',
                    getValue: (userData) => userData._id,
                    getChiledForm: () => [
                        {
                            label: 'Enable payroll for this employee',
                            name: 'enablePayroll',
                            type: 'checkbox',
                            span: 24,
                        },
                        {
                            label: 'Pay Group',
                            name: 'payGroup',
                            type: 'select',
                            isCombo: true,
                        },
                        {
                            label: 'Anual Salary',
                            name: 'anualSalary',
                            type: 'number',
                            isCombo: true,
                        },
                        {
                            span: 24,
                            type: 'custom',
                            render: () => <Text strong>Payroll Settings</Text>
                        },
                        {
                            label: 'Provident Fund (PF) Eligible',
                            name: 'pfEligible',
                            type: 'checkbox',
                            span: 24,
                        },
                        {
                            label: 'Salary Structure Type',
                            name: 'salaryStructureType',
                            type: 'select',
                            isCombo: true,
                        },
                        {
                            label: 'Custom Salary Structure',
                            name: 'customSalaryStructure',
                            type: 'select',
                            isCombo: true,
                        },
                        {
                            label: 'Tax regime to consider',
                            name: 'taxRegime',
                            type: 'select',
                            isCombo: true,
                        }
                    ],
                },
                {
                    api: () => '/users',
                    tabName: 'Settings',
                    getValue: (userData) => userData._id,
                    getChiledForm: () => [
                        {
                            label: 'Probation End Date',
                            name: 'probationEndDate',
                            type: 'date',
                        },
                        {
                            label: 'Block Account',
                            name: 'isBlock',
                            type: 'checkbox',
                            span: 24,
                        },
                        {
                            label: 'Is on Bench',
                            name: 'isOnBench',
                            type: 'checkbox',
                            span: 24,
                        },
                        {
                            label: 'Is on Notice Period',
                            name: 'isOnNoticePeriod',
                            type: 'checkbox',
                            span: 24,
                        }, {
                            label: 'Reporting HR',
                            name: 'reportingHR',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Reporting HR is required'
                            }],
                            isCombo: true,
                        },
                        {
                            label: 'Reporting BDE',
                            name: 'reportingBDE',
                            type: 'select',
                            rules: [{
                                required: true,
                                message: 'Reporting BDE is required'
                            }],
                            isCombo: true,
                        },
                        {
                            label: 'Last Working Day',
                            name: 'lastWorkingDay',
                            type: 'date',
                        },
                    ],
                },
            ];
        },
        combo: [
            {
                api: '/employee-number',
                name: 'numberSeries',
                idKey: '_id',
                render: (data) => data.name,
            },
            {
                api: '/worker-type',
                name: 'workType',
                idKey: '_id',
                render: (data) => data.name,
            },
            {
                name: 'role',
                api: '/role',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'department',
                api: '/departments',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'reportingManager',
                api: '/users/?includingme=yes',
                idKey: '_id',
                render: (e) => [e.firstName, e.middelName, e.lastName].join(' ')
            },
            {
                name: 'reportingHR',
                api: '/users/?includingme=yes',
                idKey: '_id',
                render: (e) => [e.firstName, e.middelName, e.lastName].join(' ')
            },
            {
                name: 'reportingBDE',
                api: '/users/?includingme=yes',
                idKey: '_id',
                render: (e) => [e.firstName, e.middelName, e.lastName].join(' ')
            },
            {
                name: 'timeType',
                api: '/time-type',
                idKey: '_id',
                render: (e) => e.name
            }, {
                name: 'legalEntity',
                api: '/legal-entity',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'businessUnit',
                api: '/business-unit',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'location',
                api: '/locations',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'probationPolicy',
                api: '/probation-policies',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'noticePeriod',
                api: '/notice-period',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'leavePlans',
                api: '/leave-plan',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'shiftType',
                api: '/shift-time',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'weeklyOff',
                api: '/weekly-offs',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'attendanceNumber',
                api: '/attendance-number',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'holidayList',
                api: '/holiday-list',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'attandanceCaptureScheme',
                api: '/attendance-capture-scheme',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'attandanceTrackingPolicy',
                api: '/attendance-tracking-policy',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'overtimePolicy',
                api: '/overtime',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'expensePolicy',
                api: '/expences-policy',
                idKey: '_id',
                render: (data) => data.name,
            },
            {
                name: 'payGroup',
                api: '/pay-group',
                idKey: '_id',
                render: (ele) => ele.name,
            },
            {
                name: 'salaryStructureType',
                api: '/salary-structure-type',
                idKey: '_id',
                render: (ele) => ele.name,
            },
            {
                name: 'customSalaryStructure',
                api: '/custom-salary-structure-type',
                idKey: '_id',
                render: (ele) => ele.name,
            },
            {
                name: 'taxRegime',
                api: '/tax-regime',
                idKey: '_id',
                render: (ele) => ele.name,
            },
            {
                name: 'jobTitles',
                api: '/job-titles',
                idKey: '_id',
                render: (e) => e.name
            },
        ],
        getData: () => ({}),
        actions: [
            { name: 'Add User', actionType: 'Add' },
            { name: 'Return', actionType: 'Back' },
        ],
    };

    return (
        <React.Fragment>
            <div className="mb-4 w-full flex justify-end">
                <Segmented options={['Grid', 'Table']} onChange={(e) => setView(e)} />
            </div>
            {view == 'Table' && <MasterComponent config={userConfigs} />}

            {view == 'Grid' && <InfiniteScrollList
                apiUrl="/users"
                itemsPerPage={20}
                height={665}
                listProps={{
                    grid: {
                        gutter: [16, 16],
                        xs: 1, sm: 2, md: 3, lg: 4, xl: 5, xxl: 5
                    },
                    style: { overflowX: 'hidden' }
                }}
                renderItem={(item: any) => <Card style={{ width: '95%' }}>
                    <ContactInfo
                        avatarUrl={item.avatar ? process.env.FILE_URL + item.avatar : null}
                        email={item.workEmail}
                        name={item.firstName + ' ' + item.lastName}
                        phone={item.mobile}
                        role={item?.jobTitles?.name}
                        employeeID={item.employeeId}
                    />
                </Card>
                }
            />}
        </React.Fragment >
    );
}

export default EmployeeDirectory;